import { html, nothing } from "lit";
import { translate } from "../../../../localization";
import { ExportPdf } from "../../../export-to-pdf/request";
import { ActivityHistoryMain } from "./activity-history-main";

export const template = (props: ActivityHistoryMain) =>
  html`<div class="container" ?maximized=${props.maximized}>
  ${
    props.maximized
      ? html`${headerMaximizedTemplate(props)}`
      : html`<div class="header">
            <div class="header__left">
                <div class="title">${translate("activityHistory")}</div>
                <activity-history-search-bar @onSearchChange=${props._handleSearchChange} .searchQuery=${props.searchQuery}></activity-history-search-bar>
                <dss-datepicker dropdownFixed inputsize="md" class="date-picker" @onValueChange=${(event) => props._handleSelectDate(event.detail)}>
                    <label slot="label" for="myDatepicker">${translate("goToDate")}</label>
                    <input slot="input" id="myDatepicker" type="text" class="dss-input">
                </dss-datepicker>
            </div>
            
            <div class="header__right">
                <dss-icon-button tooltipFixed @click=${() => props._refreshHistory()} size="md" variant="primary" icon="refresh" label=${translate("actions.refresh")}></dss-icon-button>
                <div>|</div>
                <dss-icon-button tooltipFixed @click=${() => props._maximize()} size="md" variant="primary" icon="open_in_full" label=${translate("actions.maximizeButton")}></dss-icon-button>
                ${
                  props.isAdministrative
                    ? nothing
                    : html`<div>|</div>
                <div>
                    <dss-icon-button tooltipFixed size="md" variant="primary" icon="more_vert" label=${translate("actions.menuButton")}></dss-icon-button>
                    <dss-action-menu position="bottom-start">
                        <dss-action-menu-item lefticon="view_timeline" label=${translate("actions.cronogram")} @click=${props._raiseEcapCronogramEvent}></dss-action-menu-item>
                        <!-- <dss-action-menu-item lefticon="file_download" label=${translate("actions.exportPdf")} @click=${() => props.api.broker.send(new ExportPdf())}></dss-action-menu-item> -->
                        <!-- <dss-action-menu-item lefticon="info" label=${translate("actions.entryLegend")}></dss-action-menu-item> -->
                    </dss-action-menu>
                </div>`
                }
            </div>
        </div>`
  } 
        <div class="wrapper" ?maximized=${props.maximized}>
          <activity-history-filters .wrapperMaximized=${props.maximized}></activity-history-filters>
          <div class="content">
            <active-filters-header></active-filters-header>
            ${props.isAnyCollectionBusy ? html`<activity-history-busy></activity-history-busy>` : nothing}
            ${props.historyGroups?.length || !props.isAnyCollectionBusy ? html`<activity-history-timeline></activity-history-timeline>` : nothing}
          </div>  
        </div>
    </div>`;

export const headerMaximizedTemplate = (props: ActivityHistoryMain) => html`
    <div class="header-maximized-container">
        <div class="header__maximized">
            <div class="header__maximized__left">
                <div class="title">${translate("activityHistory")}</div>
                <activity-history-search-bar @onSearchChange=${props._handleSearchChange} .searchQuery=${props.searchQuery}></activity-history-search-bar>
                <dss-datepicker dropdownFixed inputsize="md" class="date-picker" @onValueChange=${(event) => props._handleSelectDate(event.detail)}>
                    <label slot="label" for="myDatepicker">${translate("goToDate")}</label>
                    <input slot="input" id="myDatepicker" type="text" class="dss-input">
                </dss-datepicker>
            </div>
            <div class="header__maximized__right">
                <!-- <div>
                  <dss-button variant="subtle" size="md" label="${translate("actions.moreOptions")}" icon="more_horiz" iconposition="left"></dss-button>
                  <dss-action-menu position="bottom-start">
                    <dss-action-menu-item @click=${() => props.api.broker.send(new ExportPdf())} lefticon="file_download" label=${translate("actions.exportPdf")}></dss-action-menu-item>
                  </dss-action-menu>
                </div> -->
                <!-- <dss-button label="${translate("actions.entryLegend")}" size="md" variant="secondary"  icon="info"></dss-button> -->
                ${
                  props.isAdministrative
                    ? nothing
                    : html`<dss-button label="${translate("actions.cronogram")}" size="md" variant="primary" icon="view_timeline" @click=${props._raiseEcapCronogramEvent}></dss-button>`
                }
                <dss-icon-button tooltipFixed @click=${() => props._minimize()} size="md" variant="primary" icon="close_fullscreen" label=${translate("actions.minimizeButton")}></dss-icon-button>
            </div>
        </div>
    </div>
`;
